import styles from './PageShell.module.css';

export function PageShell({ children }: { children: React.ReactNode }) {
  return (
    <div className={styles.shell}>
      <div className="skull"></div>
      <p className={styles.wordmark}>HouseHunt </p>
      <p className={styles.note}>The assassin game</p>
      <div className={styles.stack}>{children}</div>
    </div>
  );
}
